export const tr = {
    additions: 'Eklentiler: {additionsList}'
};
